import axios from 'axios';
import { ENDPOINTS } from './ENDPOINTS';

export const ProductServices = {

    addCarDetails: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.CAR_DETAILS, data);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    updateCarDetails: async (id, data) => {
        try {
            const response = await axios.put(`${ENDPOINTS.CAR_DETAILS}/${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },

    getCarDetialById: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINTS.CAR_DETAILS}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    getAllCarDetial: async () => {
        try {
            const response = await axios.get(ENDPOINTS.CAR_DETAILS);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    getAllCarImage: async () => {
        try {
            const response = await axios.get(ENDPOINTS.CAR_IMAGE);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    getAllCarDetialAdmin: async () => {
        try {
            const response = await axios.get(ENDPOINTS.CAR_DETAIL_ADMIN);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    deleteCarDetialById: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.CAR_DETAILS}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },

    deleteUploadedFile: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.deleteFile, data);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },

    // image gallery 

    uploadImageGallery: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.image_gallery, data,
                { headers: { "Content-Type": "multipart/form-data" }, }

            );
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },

    getAllImageGallery: async () => {
        try {
            const response = await axios.get(ENDPOINTS.get_all_image_gallery);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },

    deleteImageGallery: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.get_all_image_gallery}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },

    // orders

    getAllOrders: async () => {
        try {
            const response = await axios.get(ENDPOINTS.ORDERS);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    patchOrders: async (data, id) => {
        try {
            const response = await axios.patch(
                `${ENDPOINTS.ORDERS}/${id}`,
                JSON.stringify(data),          // ✅ raw JSON
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log(response.data);
            return response.data;

        } catch (error) {
            console.error("Error updating order:", error);
            throw error;
        }
    },



}